module.exports = __webpack_public_path__ + "img/NL.67a6d920.png";